import styled from "styled-components";

import { fontStyle } from "@pages/casino/assets/styles/mixins";

export const BreadCrumbContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 54px;
	padding-right: 15px;
`;

export const TitleWrapper = styled.div`
	display: flex;
	align-items: center;
	cursor: pointer;
`;

export const Title = styled.div`
	${fontStyle}
	font-size: 12px;
	font-weight: 700;
	line-height: 20px;
	text-transform: uppercase;
`;
